import api from '../..'

export interface PublishedNormativeWithoutAttestationCountResponse {
  count: number
}

const getPublishedNormativeWithoutAttestationCount = () => {
  return api
    .get<PublishedNormativeWithoutAttestationCountResponse>(
      'administration/courses/published_normative_without_attestation_count'
    )
    .then(({ data }) => data)
}

export default getPublishedNormativeWithoutAttestationCount
